import React from 'react';
import PropTypes from 'prop-types';

import {
  Criterium,
  CriteriumTable,
  CriteriumSkeleton,
  CriteriumSnippetElement
} from '@hydra/common/criterium';
import ProgressBar from '@hydra/common/components/ProgressBar';
import { Translate } from '@hydra/common/components';
import { useReviewContext, usePdfTemplateContext } from '@hydra/common/context';

import { getContrastedColor, getPriSecColors } from '@hydra/utils/colors';
import { useI18n } from '@hydra/common/customHooks';

const MAX_AMOUNT_TO_SHOW = 10;
const MIN_IMPACT_TRESHOLD = 0.01;

export const LayoutShiftElements = ({ criterium }) => {
  const { data } = criterium;
  const { nodes, cls } = data;

  const { numeral } = useI18n();
  const { isPdf, variant } = useReviewContext();
  const { templateColors } = usePdfTemplateContext();
  const { primary } = isPdf
    ? templateColors
    : getPriSecColors();

  const color = getContrastedColor(primary);

  const head = [
    <Translate content='layout_shift_elements_element' key='element' />,
    <Translate content='layout_shift_elements_contribution' key='contribution' />
  ];

  const rows = nodes
    .filter(({ clsContribution }) => clsContribution > MIN_IMPACT_TRESHOLD)
    .slice(0, MAX_AMOUNT_TO_SHOW)
    .map(({ snippet, nodeLabel, clsContribution }, i) => {
      return [
        <CriteriumSnippetElement key={`element-${i}`} snippet={snippet} nodeLabel={nodeLabel} />,
        <div key={`progressbar-${i}`}>
          {numeral(clsContribution).format('0.[000]')}
          <ProgressBar
            value={clsContribution}
            max={cls}
            color={color}
          />
        </div>
      ];
    });

  const tableClasses = {
    body: ['verticalAlignMiddle', 'verticalAlignMiddle']
  };
  const content = (
    <>
      {
        rows.length > 0
          ? (
            <div>
              {variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='layout_shift_elements_summary' with={{ cls: numeral(cls).format('0.[000]') }} />}
              <CriteriumTable
                fixedColumns={[75, 25]}
                head={head}
                rows={rows}
                showAmount={3}
                classNames={tableClasses}
              />
            </div>
            )
          : (variant === 'nocrit' ? <CriteriumSkeleton width='60%' /> : <Translate content='layout_shift_elements_not_found' />)
      }
    </>
  );

  return <Criterium criterium={criterium}>{content}</Criterium>;
};

LayoutShiftElements.propTypes = {
  criterium: PropTypes.shape({
    data: PropTypes.shape({
      cls: PropTypes.number,
      nodes: PropTypes.arrayOf(
        PropTypes.shape({
          snippet: PropTypes.string,
          nodeLabel: PropTypes.string,
          clsContribution: PropTypes.number
        })
      )
    })
  })
};

export default React.memo(LayoutShiftElements);
